
<main class="application-profile-page" *ngIf="application as app; else applicationLoading">

    <div class="container-fluid px-0">

        <!-- BREADCRUMB -->
        <nav class="profile-breadcrumb" aria-label="breadcrumb">
            <button type="button" class="breadcrumb-back" (click)="GoBack()" aria-label="Geri dön">
                <i class="bi bi-arrow-left"></i>
            </button>

            <button type="button" (click)="GoApplications()">Uygulamalar</button>
            <i class="bi bi-chevron-right breadcrumb-separator"></i>

            <span class="breadcrumb-category">{{ app.applicationCategoryText || 'Uygulama' }}</span>
            <i class="bi bi-chevron-right breadcrumb-separator"></i>

            <span class="breadcrumb-current">{{ app.name }}</span>
        </nav>

        <!-- HERO -->
        <section class="application-hero">
            <div class="hero-banner">
                <img *ngIf="BannerImage" [src]="BannerImage" [alt]="app.name" class="hero-banner-image" />
                <div *ngIf="!BannerImage" class="hero-banner-placeholder"></div>
                <div class="hero-banner-overlay"></div>
            </div>

            <div class="application-summary">
                <div class="application-summary-left">

                    <div class="application-cover">
                        <img *ngIf="CoverImage" [src]="CoverImage" [alt]="app.name" />
                        <div *ngIf="!CoverImage" class="application-cover-fallback">
                            <img *ngIf="LogoImage" [src]="LogoImage" [alt]="app.name" />
                            <i *ngIf="!LogoImage" class="bi bi-grid-fill"></i>
                        </div>
                    </div>

                    <div class="application-title-area">
                        <div class="application-title-row">
                            <div class="application-title-copy">
                                <h1>{{ app.name }}</h1>

                                <div class="vendor-line">
                              
                                    <button type="button" class="vendor-name" (click)="OpenVendor()">
                                        {{ app.developerName || app.publisherName || 'ANAMETA' }}
                                    </button>

                                    <span class="verified-badge" *ngIf="app.isVerified" title="Doğrulanmış">
                                        <i class="bi bi-patch-check-fill"></i>
                                    </span>
                                </div>
                            </div>

                          <div class="hero-actions">

    <div class="hero-actions-top">

        <button type="button"
                class="hero-action-button"
                [class.active]="isWishlisted"
                (click)="ToggleWishlist()">

            <i [class]="isWishlisted ? 'bi bi-heart-fill' : 'bi bi-heart'"></i>
            <span>{{ isWishlisted ? 'Favorilerde' : 'Favorilere Ekle' }}</span>

        </button>

        <button type="button"
                class="hero-action-button"
                (click)="ShareApplication()">

            <i class="bi bi-share"></i>
            <span>Paylaş</span>

        </button>

    </div>

    <button type="button"
            class="start-application-button"
            (click)="StartApplication()">

        <i class="bi bi-rocket-takeoff-fill"></i>
        <span>KULLANMAYA BAŞLA</span>
        <i class="bi bi-arrow-right"></i>

    </button>

</div>
                        </div>

                        <div class="application-chips">
                            <span class="application-chip primary">
                                <i class="bi bi-grid-fill"></i>
                                {{ app.applicationTypeText || 'Uygulama' }}
                            </span>

                            <span class="application-chip" *ngIf="app.applicationCategoryText">
                                {{ app.applicationCategoryText }}
                            </span>

                            <span class="application-chip" *ngFor="let platform of app.supportedPlatforms?.slice(0, 3)">
                                {{ platform }}
                            </span>

                            <span class="application-chip" *ngIf="app.isFree">
                                Ücretsiz
                            </span>
                        </div>

                        <p class="application-summary-text">
                            {{ app.shortDescription || app.description }}
                        </p>

                        <div class="hero-media-strip" *ngIf="PreviewMedia.length > 0">
                            <button type="button" class="hero-media-item" *ngFor="let media of PreviewMedia; let i = index" (click)="OpenMedia(media)">
                                <img [src]="media.image" [alt]="app.name + ' medya ' + (i + 1)" />
                                <span *ngIf="media.type === 'video'" class="hero-media-play"><i class="bi bi-play-fill"></i></span>
                                <span *ngIf="i === 3 && RemainingMediaCount > 0" class="hero-media-more">+{{ RemainingMediaCount }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- ACTION / META PANEL -->
                <aside class="action-panel">
                    <button *ngIf="app.applicationUrl" type="button" class="primary-action-button" (click)="OpenExternal(app.applicationUrl)">
                        <span><i class="bi bi-box-arrow-up-right"></i> Uygulamayı Aç</span>
                        <i class="bi bi-arrow-right"></i>
                    </button>

                    <button *ngIf="!app.applicationUrl && app.demoUrl" type="button" class="primary-action-button" (click)="OpenExternal(app.demoUrl)">
                        <span><i class="bi bi-play-circle"></i> Demoyu Aç</span>
                        <i class="bi bi-arrow-right"></i>
                    </button>

                    <button *ngIf="app.demoUrl && app.applicationUrl" type="button" class="secondary-action-button" (click)="OpenExternal(app.demoUrl)">
                        <i class="bi bi-play-circle"></i>
                        Demo
                    </button>

                    <div class="panel-divider"></div>

                    <div class="meta-list">
                        <div class="meta-row" *ngIf="app.supportedPlatforms?.length">
                            <span class="meta-label"><i class="bi bi-window"></i> Platform</span>
                            <strong>{{ app.supportedPlatforms[0] }}</strong>
                        </div>

                        <div class="meta-row" *ngIf="app.version">
                            <span class="meta-label"><i class="bi bi-clock-history"></i> Son Sürüm</span>
                            <strong>{{ app.version }}</strong>
                        </div>

                        <div class="meta-row" *ngIf="app.year">
                            <span class="meta-label"><i class="bi bi-calendar3"></i> Yıl</span>
                            <strong>{{ app.year }}</strong>
                        </div>

                        <div class="meta-row" *ngIf="app.developerName">
                            <span class="meta-label"><i class="bi bi-people"></i> Geliştirici</span>
                            <strong>{{ app.developerName }}</strong>
                        </div>

                        <div class="meta-row" *ngIf="app.publisherName">
                            <span class="meta-label"><i class="bi bi-building"></i> Yayıncı</span>
                            <strong>{{ app.publisherName }}</strong>
                        </div>

                        <div class="meta-row">
                            <span class="meta-label"><i class="bi bi-activity"></i> Durum</span>
                            <strong class="status-value" [class.inactive]="!app.isActive">
                                <span class="status-dot"></span>
                                {{ app.isActive ? 'Aktif' : 'Pasif' }}
                            </strong>
                        </div>
                    </div>
                </aside>
            </div>
        </section>

        <!-- TABS -->
        <nav class="profile-tabs">
            <button type="button" *ngFor="let tab of tabs" [class.active]="activeTab === tab.id" (click)="SetActiveTab(tab.id)">
                <i [class]="GetTabIcon(tab.id)"></i>
                <span>{{ tab.name }}</span>
                <span *ngIf="tab.count" class="tab-counter">{{ tab.count }}</span>
            </button>
        </nav>

        <!-- OVERVIEW -->
        <div class="profile-content-grid" *ngIf="activeTab === 'overview'">
            <div class="profile-left-column">

                <section class="content-card overview-card">
                    <div class="card-heading">
                        <h2><i class="bi bi-compass"></i> Genel Bakış</h2>
                    </div>

                    <p class="overview-description">
                        {{ app.description || app.shortDescription }}
                    </p>

                    <div class="feature-grid">
                        <article class="feature-box" *ngFor="let feature of FeatureItems; let i = index">
                            <span class="feature-icon" [class.green]="i === 0" [class.blue]="i === 1" [class.orange]="i === 2" [class.purple]="i === 3">
                                <i [class]="feature.icon"></i>
                            </span>
                            <div>
                                <h3>{{ feature.title }}</h3>
                                <p>{{ feature.description }}</p>
                            </div>
                        </article>
                    </div>
                </section>

                <section class="content-card media-section" *ngIf="GalleryMedia.length > 0">
                    <div class="card-heading card-heading-between">
                        <h2><i class="bi bi-image"></i> Medya</h2>
                        <button type="button" class="link-button" (click)="SetActiveTab('media')">Tümünü Gör <i class="bi bi-arrow-right"></i></button>
                    </div>

                    <div class="media-gallery-wide">
                        <button type="button" class="media-gallery-item" *ngFor="let media of GalleryMedia; let i = index" [class.main]="i === 0" (click)="OpenMedia(media)">
                            <img [src]="media.image" [alt]="app.name + ' medya ' + (i + 1)" />
                            <span *ngIf="media.type === 'video'" class="gallery-play"><i class="bi bi-play-fill"></i></span>
                            <span *ngIf="i === GalleryMedia.length - 1 && RemainingGalleryCount > 0" class="gallery-more">+{{ RemainingGalleryCount }}</span>
                        </button>
                    </div>
                </section>

                <section class="content-card detail-description-card">
                    <div class="card-heading">
                        <h2><i class="bi bi-file-earmark-text"></i> Detaylı Açıklama</h2>
                    </div>
                    <p>{{ app.description || app.shortDescription }}</p>
                </section>
            </div>

            <aside class="profile-right-column">

                <section class="side-card statistics-card">
                    <div class="card-heading card-heading-between">
                        <h2><i class="bi bi-bar-chart"></i> İstatistikler</h2>
                        <span class="period-text">Toplam</span>
                    </div>

                    <div class="statistic-list">
                        <div class="statistic-row">
                            <strong class="green">{{ app.viewCount | number }}</strong>
                            <div class="statistic-info">
                                <span>Görüntülenme</span>
                                <div class="progress"><div class="progress-bar stat-green" [style.width.%]="ViewProgress"></div></div>
                            </div>
                        </div>

                        <div class="statistic-row">
                            <strong class="blue">{{ app.downloadCount | number }}</strong>
                            <div class="statistic-info">
                                <span>İndirme</span>
                                <div class="progress"><div class="progress-bar stat-blue" [style.width.%]="DownloadProgress"></div></div>
                            </div>
                        </div>

                        <div class="statistic-row">
                            <strong class="orange">{{ app.ratingAverage | number:'1.1-1' }}</strong>
                            <div class="statistic-info">
                                <span>Puan / {{ app.ratingCount | number }} değerlendirme</span>
                                <div class="progress"><div class="progress-bar stat-orange" [style.width.%]="RatingProgress"></div></div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="side-card information-card">
                    <div class="card-heading">
                        <h2><i class="bi bi-info-circle"></i> Uygulama Bilgileri</h2>
                    </div>

                    <div class="information-list">
                        <div class="information-row" *ngIf="app.version">
                            <span><i class="bi bi-box"></i> Sürüm</span>
                            <strong>{{ app.version }}</strong>
                        </div>
                        <div class="information-row" *ngIf="app.year">
                            <span><i class="bi bi-calendar3"></i> Yıl</span>
                            <strong>{{ app.year }}</strong>
                        </div>
                        <div class="information-row" *ngIf="app.developerName">
                            <span><i class="bi bi-people"></i> Geliştirici</span>
                            <strong>{{ app.developerName }}</strong>
                        </div>
                        <div class="information-row" *ngIf="app.publisherName">
                            <span><i class="bi bi-building"></i> Yayıncı</span>
                            <strong>{{ app.publisherName }}</strong>
                        </div>
                        <button type="button" class="information-row information-link" *ngIf="app.websiteUrl" (click)="OpenExternal(app.websiteUrl)">
                            <span><i class="bi bi-globe2"></i> Web Sitesi</span>
                            <strong>Görüntüle <i class="bi bi-box-arrow-up-right"></i></strong>
                        </button>
                        <button type="button" class="information-row information-link" *ngIf="app.supportUrl" (click)="OpenExternal(app.supportUrl)">
                            <span><i class="bi bi-life-preserver"></i> Destek</span>
                            <strong>Görüntüle <i class="bi bi-box-arrow-up-right"></i></strong>
                        </button>
                        <button type="button" class="information-row information-link" *ngIf="app.statusPageUrl" (click)="OpenExternal(app.statusPageUrl)">
                            <span><i class="bi bi-activity"></i> Durum Sayfası</span>
                            <strong>Görüntüle <i class="bi bi-box-arrow-up-right"></i></strong>
                        </button>
                        <button type="button" class="information-row information-link" *ngIf="app.documentationUrl" (click)="OpenExternal(app.documentationUrl)">
                            <span><i class="bi bi-journal-text"></i> Belgeler</span>
                            <strong>Görüntüle <i class="bi bi-box-arrow-up-right"></i></strong>
                        </button>
                    </div>
                </section>

                <section class="side-card requirements-card" *ngIf="app.minimumRequirements?.length || app.recommendedRequirements?.length">
                    <div class="card-heading">
                        <h2><i class="bi bi-gear"></i> Sistem Gereksinimleri</h2>
                    </div>

                    <div class="requirements-tabs">
                        <button type="button" [class.active]="requirementMode === 'minimum'" (click)="requirementMode = 'minimum'">Minimum</button>
                        <button type="button" [class.active]="requirementMode === 'recommended'" (click)="requirementMode = 'recommended'">Önerilen</button>
                    </div>

                    <div class="requirements-list">
                        <div class="requirement-row" *ngFor="let requirement of ActiveRequirements">
                            <i class="bi bi-check2-circle"></i>
                            <span>{{ requirement }}</span>
                        </div>
                    </div>
                </section>

                <section class="side-card access-card" *ngIf="app.purchaseOptions?.length">
                    <div class="card-heading">
                        <h2><i class="bi bi-key"></i> Erişim Bilgileri</h2>
                    </div>

                    <div class="purchase-option" *ngFor="let option of app.purchaseOptions">
                        <div class="purchase-option-title">{{ option.acquisitionTypeText }}</div>
                        <div class="purchase-tags">
                            <span *ngFor="let item of option.billingTypeNames">{{ item }}</span>
                            <span *ngFor="let item of option.accessTypeNames">{{ item }}</span>
                            <span *ngFor="let item of option.licenseTypeNames">{{ item }}</span>
                        </div>
                    </div>
                </section>

            </aside>
        </div>

        <!-- MEDIA TAB -->
        <section class="tab-card" *ngIf="activeTab === 'media'">
            <div class="card-heading"><h2><i class="bi bi-images"></i> Medya</h2></div>
            <div class="media-tab-grid">
                <button type="button" *ngFor="let media of AllMedia" (click)="OpenMedia(media)">
                    <img [src]="media.image" [alt]="app.name" />
                    <span *ngIf="media.type === 'video'"><i class="bi bi-play-fill"></i></span>
                </button>
            </div>
        </section>

        <!-- FEATURES TAB -->
        <section class="tab-card" *ngIf="activeTab === 'features'">
            <div class="card-heading"><h2><i class="bi bi-stars"></i> Özellikler</h2></div>
            <div class="tag-cloud">
                <span *ngFor="let tag of app.tags">{{ tag }}</span>
                <span *ngFor="let platform of app.supportedPlatforms">{{ platform }}</span>
                <span *ngFor="let os of app.supportedOperatingSystems">{{ os }}</span>
            </div>
        </section>

        <!-- REQUIREMENTS TAB -->
        <section class="tab-card" *ngIf="activeTab === 'requirements'">
            <div class="card-heading"><h2><i class="bi bi-pc-display"></i> Sistem Gereksinimleri</h2></div>
            <div class="requirements-detail-grid">
                <div>
                    <h3>Minimum</h3>
                    <div class="requirement-detail-item" *ngFor="let item of app.minimumRequirements"><i class="bi bi-check2"></i>{{ item }}</div>
                </div>
                <div>
                    <h3>Önerilen</h3>
                    <div class="requirement-detail-item" *ngFor="let item of app.recommendedRequirements"><i class="bi bi-check2"></i>{{ item }}</div>
                </div>
            </div>
        </section>

        <!-- COMMENTS TAB -->
        <section class="tab-card empty-tab" *ngIf="activeTab === 'comments'">
            <i class="bi bi-chat-left-text"></i>
            <h2>Yorumlar</h2>
            <p>Yorum alanı sonraki adımda bağlanabilir.</p>
        </section>

        <!-- SUPPORT TAB -->
        <section class="tab-card" *ngIf="activeTab === 'support'">
            <div class="card-heading"><h2><i class="bi bi-life-preserver"></i> Destek</h2></div>
            <div class="support-grid">
                <button *ngIf="app.supportUrl" type="button" (click)="OpenExternal(app.supportUrl)"><i class="bi bi-globe"></i><span><strong>Destek Merkezi</strong><small>{{ app.supportUrl }}</small></span></button>
                <a *ngIf="app.supportEmail" [href]="'mailto:' + app.supportEmail"><i class="bi bi-envelope"></i><span><strong>E-posta</strong><small>{{ app.supportEmail }}</small></span></a>
                <a *ngIf="app.supportPhone" [href]="'tel:' + app.supportPhone"><i class="bi bi-telephone"></i><span><strong>Telefon</strong><small>{{ app.supportPhone }}</small></span></a>
                <button *ngIf="app.documentationUrl" type="button" (click)="OpenExternal(app.documentationUrl)"><i class="bi bi-journal-text"></i><span><strong>Dokümantasyon</strong><small>{{ app.documentationUrl }}</small></span></button>
            </div>
        </section>

    </div>
</main>

<ng-template #applicationLoading>
    <div class="application-loading">
        <div class="spinner-border text-danger" role="status"></div>
        <span>Uygulama bilgileri yükleniyor...</span>
    </div>
</ng-template>